<template>
    <div>

        <div v-if="type === conejos">

            <div class="columns">
                <div class="column is-2">

                </div>

                <div class="column is-8">
                   
                    <div class="columns">
                        <div class="column">
                            <p>
                                <strong>COMPOSICION CENTESIMAL</strong>
                            </p>
                            <table class="table is-bordered is-striped is-narrow is-fullwidth">
                                <tr>
                                    <td>PROTEINA BRUTA</td>
                                    <td>16% Mín.</td>
                                </tr>
                                <tr>
                                    <td>FIBRA BRUTA </td>
                                    <td>20% Mín. - 25% Máx.</td>
                                </tr>
                                <tr>
                                    <td>FIBRA BRUTA</td>
                                    <td> 20% Mín.</td>
                                </tr>
                                <tr>
                                    <td>GRASA BRUTA</td>
                                    <td> 3% Mín.</td>
                                </tr>
                                <tr>
                                    <td>CALCIO </td>
                                    <td>0,8% Mín. - 1 % Máx.</td>
                                </tr>
                                <tr>
                                    <td>FOSFORO </td>
                                    <td>0,4% Mín. - 0,5% Máx.</td>
                                </tr>
                                <tr>
                                    <td>HUMEDAD</td>
                                    <td> 13% Máx.</td>
                                </tr>
                                <tr>
                                    <td>Energía Metabolizante </td>
                                    <td>1.800 Kcal por kg.</td>
                                </tr>

                            </table>
                        </div>
                        <div class="column">
                            <p>
                                <strong>ADITIVOS por kg</strong>
                            </p>
                            <table class="table is-bordered is-striped is-narrow is-fullwidth">
                                <tr>
                                    <td> VITAMINA A</td>
                                    <td> 10.000 UI.</td>
                                </tr>

                                <tr>
                                    <td>VITAMINA D3</td>
                                    <td> 1.500 UI.</td>
                                </tr>
                                <tr>
                                    <td>VITAMINA E </td>
                                    <td>
                                        50 UI.</td>
                                </tr>

                                <div class="column is-2">

                                </div>

                            </table>
                        </div>
                    </div>

                </div>
                <div class="column is-2">

                </div>

            </div>

        </div>
        <div v-if="type === chinchillas">
            <div class="columns">
                <div class="column is-2">

                </div>

                <div class="column is-8">
                   
                    <div class="columns">
                        <div class="column">
                            <p>
                                <strong>COMPOSICION CENTESIMAL</strong>
                            </p>
                            <table class="table is-bordered is-striped is-narrow is-fullwidth">
                                <tr>
                                    <td>PROTEINA BRUTA</td>
                                    <td>17% Mín.</td>
                                </tr>
                                <tr>
                                    <td>FIBRA BRUTA </td>
                                    <td>18% Máx.</td>
                                </tr>
                                <tr>
                                    <td>FIBRA BRUTA</td>
                                    <td> 20% Mín.</td>
                                </tr>
                                <tr>
                                    <td>GRASA BRUTA</td>
                                    <td> 3% Mín.</td>
                                </tr>
                                <tr>
                                    <td>CALCIO </td>
                                    <td> 0,9% Mín. - 1 % Máx.</td>
                                </tr>
                                <tr>
                                    <td>FOSFORO </td>
                                    <td>0,4% Mín. - 0,6% Máx.</td>
                                </tr>
                                <tr>
                                    <td>HUMEDAD</td>
                                    <td> 13% Máx.</td>
                                </tr>
                                <tr>
                                    <td>Energía Metabolizante </td>
                                    <td>2.300 Kcal por kg.</td>
                                </tr>

                            </table>
                        </div>
                        <div class="column">
                            <p>
                                <strong>ADITIVOS por kg</strong>
                            </p>

                            <table class="table is-bordered is-striped is-narrow is-fullwidth">
                                <tr>
                                    <td> VITAMINA A</td>
                                    <td> 9.000 UI.</td>
                                </tr>
                                <tr>
                                    <td>VITAMINA D3 </td>
                                    <td> 900 UI.</td>
                                </tr>
                                <tr>
                                    <td>VITAMINA E </td>
                                    <td> 90 UI.</td>
                                </tr>
                                <tr>
                                    <td>VITAMINA C </td>
                                    <td>
                                        75 mg.</td>
                                </tr>
                                <tr>
                                    <td>Cloruro colina </td>
                                    <td>
                                        150 mg.</td>
                                </tr>
                                <tr>
                                    <td>Cu </td>
                                    <td>
                                        30 mg.</td>
                                </tr>
                                <tr>
                                    <td>Zn </td>
                                    <td>
                                        80 mg.</td>
                                </tr>
                                <tr>
                                    <td>Mn </td>
                                    <td>
                                        40 mg.</td>
                                </tr>
                                <tr>
                                    <td>Fe </td>
                                    <td>
                                        50 mg.</td>
                                </tr>
                                <tr>
                                    <td>Se </td>
                                    <td>
                                        0,4 mg.</td>
                                </tr>

                                <div class="column is-2">

                                </div>

                            </table>
                        </div>
                    </div>

                </div>
                <div class="column is-2">

                </div>

            </div>

        </div>
    </div>
</template>
<script>
export default {
  name: "data-table",
  data() {
    return {
      chinchillas: "chinchillas",
      conejos: "conejos"
    };
  },
  props: {
    type: String
  }
};
</script>



// WEBPACK FOOTER //
// src/components/products-components/dataTable.vue